import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function ArrayLengthNotSmaller(min:number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    return control.value?(control.value.split(/[, ;\n]+/).filter(v => v.length > 0).length < min ? {'appArrayLengthNotSmaller': {value: control.value}} : null) : null;
  };
}

@Directive({
  selector: '[appArrayLengthNotSmaller]',
  providers: [{provide: NG_VALIDATORS, useExisting: ArrayLengthNotSmallerDirective, multi: true}]
})
export class ArrayLengthNotSmallerDirective {
  @Input('appArrayLengthNotSmaller') min: number;
 
  validate(control: AbstractControl): {[key: string]: any} {
    return this.min ? ArrayLengthNotSmaller(this.min)(control)
                              : null;
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
 
    if ('min' in changes) {
      
      if (this._onChange) this._onChange();
    }
  }

}
